<!--
/*******************************************************************************
*@ 컴포넌트명   : AccountBoxHeader.vue
*@ 컴포넌트설명 : 계좌내역 요약
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역 
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <div class="box-white -type3">
      <div class="header">
        <div class="col">
          {{ /*Total Account*/ $t("MINQ-01-01-02-12") }} :
          <em>{{ summary.brifAcnCnt }}</em>
        </div>
        <div class="col text">{{ /*합계*/ $t("MINQ-01-01-01-05") }}</div>
      </div>
      <div class="content">
        <div class="account-info -type2">
          <div class="item amount" v-for="(item, i) in summary.info" :key="i">
            <span class="exchange-unit">
              {{ item.brifCncycd }}
              <em>{{ `(${item.brifAcnCnt})` }}</em>
            </span>
            <span class="total" v-html="$num(item.brifTotalBal, null, true)"></span>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: "AccountBoxHeader",
  props: {
    summary: {
      type: Object,
      required: true,
    },
  },
};
</script>

